import * as React from "react";
import { createColumnHelper } from "@tanstack/react-table";

import { SupportTopOffendersData } from "src/core/dashboard/api/widget-data.api";
import { customCreateColumnHelper } from "src/core/dashboard/components/widgets/table/customColumnHelper";
import { Text } from "src/library/components/Text";
import { formatDropName } from "src/core/drops/utils/format-drop-name";
import { formatCustomerName } from "src/core/customers/utils/format-customer-name";

export const getSupportTopOffendersTableColumns = () => {
  const customColumnHelper = customCreateColumnHelper<SupportTopOffendersData>();
  const columnHelper = createColumnHelper<SupportTopOffendersData>();

  return [
    customColumnHelper.standardTextColumn(columnHelper, "branchName", {
      header: "Delivery Point",
      enableSorting: false,
      cell: ({ row }) => (
        <Text>
          <>
            {formatDropName({
              name: row.original.branchName,
              branchNumber: row.original.branchNumber
            })}
          </>
        </Text>
      )
    }),
    customColumnHelper.standardTextColumn(columnHelper, "customerName", {
      header: "Customer",
      enableSorting: false,
      cell: ({ row }) => {
        return (
          <Text>
            <>
              {formatCustomerName({
                name: row.original.customerName,
                accountNumber: row.original.customerNumber
              })}
            </>
          </Text>
        );
      }
    }),
    customColumnHelper.numberColumn(columnHelper, "totalTickets", { header: "Total Tickets" }),
    customColumnHelper.numberColumn(columnHelper, "totalUnresolved", { header: "Total Unresolved" }),
    customColumnHelper.numberColumn(columnHelper, "totalResolved", { header: "Total Resolved" }),
    customColumnHelper.timeColumn(columnHelper, "totalTimeTaken", { header: "Total Time Taken (HH:mm)" })
  ];
};